<template>
    <div class="">
        <label v-if="label" class="v-label v-label--active theme--light" style="font-size: 10px;">{{ label }}</label>
        <input type="file"
               ref="file_input"
               :id="file_input_id_"
               class="w-100"
               :class="[{'_file_input mb-2': !loading}, file_input_classes]"
               :name="name"
               :dusk="dusk"
               @input="changed"
               :multiple="multiple"
               :accept="accept"/>
        <v-progress-linear class="mt-0 mb-2" height="2" v-if="loading" indeterminate></v-progress-linear>
        <v-messages
                    :value="getMessages()"
                    :color="messageColor()"
        ></v-messages>
    </div>
</template>

<script>
    export default {
        name: "FileInput",
        props: {
            label: String,
            loading: Boolean,
            message: {},
            name: {},
            accept: {},
            multiple: Boolean,
            errorMessages: [Array, String],
            dusk: '',
            file_input_id: false,
            file_input_classes: ""
        },
        data() {
            return {
                file_input_id_: ''
            }
        },
        mounted() {
            this.file_input_id ? this.file_input_id_ = this.file_input_id : this.file_input_id_ = this._uid
        },
        methods: {
            changed(e) {
                this.$emit('change', e);
                this.$emit('input', e);
            },
            reset() {
                this.$refs.file_input.value = ''
            },
            getMessages() {
                return this.message ? [this.message] : ( typeof this.errorMessages === 'string' ? [this.errorMessages] : this.errorMessages )
            },
            messageColor() {
                return this.errorMessages && this.errorMessages.length ? 'error' : ''
            }
        }
    }
</script>

<style scoped>
    ._file_input {
        border-color: rgba(0,0,0,.42);
        border-width: 0 0 thin 0;
        border-style: solid;
    }
</style>